import Grid from '../components/grid'
import Container from '../components/ui/container'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetType } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'enterprise-diagram' }>

function EnterpriseDiagram(block: BlockProps): ReactElement {
  const { image } = block
  return (
    <Container>
      <Grid>
        <div className="relative col-span-full flex justify-center items-center">
          <Asset
            resource={image as AssetType}
            imgClassName="py-4 object-contain object-center"
            width={1400}
            height={800}
          />
        </div>
      </Grid>
    </Container>
  )
}

export default EnterpriseDiagram
